// Keuzes van de 4-staps offertevergelijker. Waarden komen overeen met de backend (quote_compare_api).
import { getAttribution } from "../../lib/api";

export const COMPARE_STEPS = [
  { title: "Uw bestaande offerte", short: "Offerte" },
  { title: "Product en specificaties", short: "Product" },
  { title: "Afmetingen en foto's", short: "Maten" },
  { title: "Uw contactgegevens", short: "Contact" },
];

export const GOALS = [
  { id: "prijs", label: "Is de prijs marktconform?" },
  { id: "compleetheid", label: "Is de offerte compleet?" },
  { id: "alternatief", label: "Graag een alternatieve offerte" },
  { id: "advies", label: "Advies over product en uitvoering" },
];

export const VAT_OPTIONS = [
  { id: "incl", label: "Inclusief btw" },
  { id: "excl", label: "Exclusief btw" },
  { id: "onbekend", label: "Weet ik niet" },
];

export const COMPARE_GLAZING = [
  { id: "hr_plus_plus", label: "HR++ glas" },
  { id: "hr_triple", label: "HR+++ (triple) glas" },
  { id: "onbekend", label: "Staat er niet in / weet ik niet" },
];

export const INCLUDES = [
  { id: "demontage", label: "Demontage oude kozijnen" }, { id: "afvoer", label: "Afvoer" },
  { id: "montage", label: "Montage" }, { id: "glas", label: "Glas" },
  { id: "afwerking_binnen", label: "Afwerking binnen" }, { id: "afwerking_buiten", label: "Afwerking buiten" },
  { id: "vensterbanken", label: "Vensterbanken" }, { id: "ventilatieroosters", label: "Ventilatieroosters" },
];

export const MAX_OFFER_FILES = 6;
export const MAX_ITEMS = 20;
export const COMPARE_DONE_KEY = "mk_compare_done";

export const newItem = () => ({ key: Math.random().toString(36).slice(2), description: "", width: "", height: "", quantity: "1" });

// "8.450", "8450,50", "€ 12.000,-" → getal; leeg of ongeldig → null
export const parseEuro = (raw) => {
  let s = String(raw || "").replace(/[€\s]/g, "").replace(/,-$/, "");
  if (!s) return null;
  s = /,\d{1,2}$/.test(s) ? s.replace(/\./g, "").replace(",", ".") : s.replace(/[.,]/g, "");
  const n = Number(s);
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const priceError = (raw) => {
  if (!String(raw || "").trim()) return "";
  const n = parseEuro(raw);
  if (n === null) return "Vul een bedrag in, bijvoorbeeld 8.450";
  if (n < 100 || n > 1000000) return "Vul een bedrag tussen € 100 en € 1.000.000 in";
  return "";
};

export const offerStepError = (form, offers) =>
  priceError(form.price) || (!parseEuro(form.price) && !offers.some((u) => u.path) ? "Vul het offertebedrag in of upload uw offerte om verder te gaan." : "");

const num = (v) => (String(v).trim() ? Math.round(Number(String(v).replace(",", "."))) : null);
export const itemError = (it) => {
  const bad = [it.width, it.height].some((v) => String(v).trim() && !(num(v) >= 10 && num(v) <= 1500));
  return bad ? "Maten in cm tussen 10 en 1500" : "";
};

export const buildComparePayload = ({ form, offers, photos, items, meta }) => {
  const attr = getAttribution();
  const paths = (list) => list.filter((u) => u.path).map((u) => u.path);
  return {
    idempotency_key: meta.key, lead_type: "quote_comparison", product_category: form.product || "anders",
    offer_price: parseEuro(form.price), offer_vat: form.vat || "onbekend", competitor: form.competitor.trim(),
    offer_files: paths(offers), uploaded_files: paths(photos),
    specs: { goal: form.goal, profile_system: form.profile_system.trim(), glazing: form.glazing || "onbekend",
      color: form.color || "", includes: form.includes },
    items: items.filter((i) => i.description.trim() || num(i.width) || num(i.height)).map((i) => ({
      description: i.description.trim(), width_cm: num(i.width), height_cm: num(i.height), quantity: Math.max(1, num(i.quantity) || 1),
    })),
    postal_code: form.postcode.trim(), locality: form.woonplaats.trim(), notes: form.notes.trim(),
    contact_name: form.naam.trim(), email: form.email.trim(), phone: form.telefoon.trim(), consent_privacy: true,
    marketing_opt_in: false, utm: attr.utm || {}, referrer: attr.referrer || "", landing_page: attr.landing_page || "",
    source_page: meta.source, website: form.website, elapsed_ms: Date.now() - meta.startedAt,
  };
};
